<template>
  <div>
    <opq-basic-appbar v-if="!noAppbar"><slot name="title"></slot> &mdash; Ordre des psychologues du Québec</opq-basic-appbar>

    <v-main>
      <v-sheet max-width="1200" class="ml-6 py-4 py-md-8 py-lg-12 px-2 px-md-6 px-lg-12">
        <slot></slot>
      </v-sheet>
    </v-main>
  </div>
</template>

<script>
export default {
  props: {
    noAppbar: {
      type: Boolean,
      default: false
    }
  }
}
</script>
